
export type MonitorRecommendType = 'SUBSCRIBE' | 'DEFAULT' | '';

export interface MonitorItem {
    news_letter_id: number;
    title: string;
}

export interface MonitorRecommendApiResponse {
    detail: MonitorItem[];
    recommend_type: MonitorRecommendType;
}

export const MonitorSuggestApi = Symbol('MonitorSuggestApi');

export interface MonitorSuggestApi {
    getMonitorRecommendList(): Promise<MonitorRecommendApiResponse>
}
